import Immutable from 'seamless-immutable';
import _ from 'lodash';
import moment from 'moment';

import {
  SAVE_INTERCOMS,
  SAVE_EXTENSIONS,
  SAVE_EXTENSION_GROUPS,
  SAVE_INTERCOM_EXTENSIONS,
  SAVE_HYPER_TILES,

  APPEND_INTERCOMS,
  APPEND_EXTENSIONS,
  APPEND_EXTENSION_GROUPS,
  APPEND_INTERCOM_EXTENSIONS,
  APPEND_HYPER_TILES,
  
  SET_INTERCOMS_PAGINATION_DATA,
  RESET_INTERCOMS_PAGINATION_DATA,
  SET_EXTENSIONS_PAGINATION_DATA,
  RESET_EXTENSIONS_PAGINATION_DATA,
  SET_EXTENSION_GROUPS_PAGINATION_DATA,
  RESET_EXTENSION_GROUPS_PAGINATION_DATA,
  SET_INTERCOM_EXTENSIONS_PAGINATION_DATA,
  RESET_INTERCOM_EXTENSIONS_PAGINATION_DATA,
  SET_HYPER_TILES_PAGINATION_DATA,
  RESET_HYPER_TILES_PAGINATION_DATA,

  SELECT_INTERCOM,
  SELECT_EXTENSION,
  SELECT_HYPER_TILE,

  RESET_INTERCOMS_FILTERS,
  SET_INTERCOM_FILTER,
  RESET_EXTENSIONS_FILTERS,
  SET_EXTENSION_FILTER,

  SET_INTERCOM_OPERATIONAL_MODE,
  SET_EXTENSION_OPERATIONAL_MODE,

  SET_INTERCOM_ORDER,
  SET_EXTENSION_ORDER,
  
  UPDATE_INTERCOM,
  UPDATE_EXTENSION,
  UPDATE_EXTENSION_GROUP,
  UPDATE_HYPER_TILE,

  SAVE_ALL_EXTENSIONS,

  SET_INTERCOM_LOCKS_FILTERED_BY_TAGS,
  APPEND_INTERCOM_LOCKS_FILTERED_BY_TAGS,
  SET_INTERCOM_LOCKS_FILTERED_BY_TAGS_PAGINATION_DATA,

  SET_EXTENSION_USERS_FILTERED_BY_TAGS,
  APPEND_EXTENSION_USERS_FILTERED_BY_TAGS,
  SET_EXTENSION_USERS_FILTERED_BY_TAGS_PAGINATION_DATA,
  
  SAVE_VIRTUAL_INTERCOM_LIMITS,
} from '../actions/actionTypes/intercom';

const initialState = Immutable({
  data: {
    content: [],
    filters: {},
    pagination: {},
    sorting: {
      orderBy: undefined,
      orderDir: undefined,
    },
    lastUpdate: 0,
  },
  extensions: {
    content: [],
    filters: {},
    pagination: {},
    sorting: {
      orderBy: undefined,
      orderDir: undefined,
    },
    lastUpdate: 0,
  },
  extensionGroups: {
    content: [],
    pagination: {},
    lastUpdate: 0,
  },
  intercomExtensions: {
    content: [],
    pagination: {},
    lastUpdate: 0,
  },
  hyperTiles: {
    content: [],
    pagination: {},
    lastUpdate: 0,
  },
  selectedIntercom: {},
  selectedExtension: {},
  selectedHyperTile: {},
  isOperationalMode: false,
  isOperationalModeExtensions: false,
  allExtensions: [],
  virtualIntercomLimits: null,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case SAVE_INTERCOMS:
      return state.setIn(['data', 'content'], action.intercoms).setIn(['data', 'lastUpdate'], moment().valueOf());
    case APPEND_INTERCOMS:
      return state.setIn(['data', 'content'], [...state.data.content, ...action.intercoms]).setIn(['data', 'lastUpdate'], moment().valueOf());
    case SET_INTERCOMS_PAGINATION_DATA:
      return state.setIn(['data', 'pagination'], action.pagination);
    case RESET_INTERCOMS_PAGINATION_DATA:
      return state.setIn(['data', 'pagination'], {});
    case SELECT_INTERCOM:
      return state.set('selectedIntercom', action.intercom);
    case RESET_INTERCOMS_FILTERS:
      return state.setIn(['data', 'filters'], {});
    case SET_INTERCOM_FILTER:
      return state.setIn(['data', 'filters', action.name], action.value);
    case UPDATE_INTERCOM: {
      const index = _.findIndex(state.data.content, data => data.id === action.intercom.id);
      if (index !== -1) {
        return state.setIn(['data', 'content', index], action.intercom);
      }
      return state;
    }
    case SET_INTERCOM_OPERATIONAL_MODE:
      return state.set('isOperationalMode', action.value);
    case SET_INTERCOM_ORDER:
      return state.setIn(['data', 'sorting', 'orderBy'], action.orderBy)
                  .setIn(['data', 'sorting', 'orderDir'], action.orderDir);
    case SAVE_EXTENSIONS:
      return state.setIn(['extensions', 'content'], action.extensions).setIn(['extensions', 'lastUpdate'], moment().valueOf());
    case APPEND_EXTENSIONS:
      return state.setIn(['extensions', 'content'], [...state.extensions.content, ...action.extensions]).setIn(['extensions', 'lastUpdate'], moment().valueOf());
    case SET_EXTENSIONS_PAGINATION_DATA:
      return state.setIn(['extensions', 'pagination'], action.pagination);
    case RESET_EXTENSIONS_PAGINATION_DATA:
      return state.setIn(['extensions', 'pagination'], {});
    case SELECT_EXTENSION:
      return state.set('selectedExtension', action.extension);
    case UPDATE_EXTENSION: {
      const index = _.findIndex(state.extensions.content, extension => extension.id === action.extension.id);
      if (index !== -1) {
        return state.setIn(['extensions', 'content', index], action.extension);
      }
      return state;
    }
    case SET_EXTENSION_OPERATIONAL_MODE:
      return state.set('isOperationalModeExtensions', action.value);
    case RESET_EXTENSIONS_FILTERS:
      return state.setIn(['extensions', 'filters'], {});
    case SET_EXTENSION_FILTER:
      return state.setIn(['extensions', 'filters', action.name], action.value);
    case SET_EXTENSION_ORDER:
      return state.setIn(['extensions', 'sorting', 'orderBy'], action.orderBy)
                  .setIn(['extensions', 'sorting', 'orderDir'], action.orderDir);
    case SAVE_EXTENSION_GROUPS:
      return state.setIn(['extensionGroups', 'content'], action.groups).setIn(['extensionGroups', 'lastUpdate'], moment().valueOf());
    case APPEND_EXTENSION_GROUPS:
      return state.setIn(['extensionGroups', 'content'], [...state.extensionGroups.content, ...action.groups]).setIn(['extensionGroups', 'lastUpdate'], moment().valueOf());
    case SET_EXTENSION_GROUPS_PAGINATION_DATA:
      return state.setIn(['extensionGroups', 'pagination'], action.pagination);
    case RESET_EXTENSION_GROUPS_PAGINATION_DATA:
      return state.setIn(['extensionGroups', 'pagination'], {});
    case UPDATE_EXTENSION_GROUP: {
      const index = _.findIndex(state.extensionGroups.content, group => group.id === action.group.id);
      if (index !== -1) {
        return state.setIn(['extensionGroups', 'content', index], action.group);
      }
      return state;
    }
    case SAVE_INTERCOM_EXTENSIONS:
      return state.setIn(['intercomExtensions', 'content'], action.extensions).setIn(['intercomExtensions', 'lastUpdate'], moment().valueOf());
    case APPEND_INTERCOM_EXTENSIONS:
      return state.setIn(['intercomExtensions', 'content'], [...state.intercomExtensions.content, ...action.extensions]).setIn(['intercomExtensions', 'lastUpdate'], moment().valueOf());
    case SET_INTERCOM_EXTENSIONS_PAGINATION_DATA:
      return state.setIn(['intercomExtensions', 'pagination'], action.pagination);
    case RESET_INTERCOM_EXTENSIONS_PAGINATION_DATA:
      return state.setIn(['intercomExtensions', 'pagination'], {});
    case SAVE_HYPER_TILES:
      return state.setIn(['hyperTiles', 'content'], action.tiles).setIn(['hyperTiles', 'lastUpdate'], moment().valueOf());
    case APPEND_HYPER_TILES:
      return state.setIn(['hyperTiles', 'content'], [...state.hyperTiles.content, ...action.tiles]).setIn(['hyperTiles', 'lastUpdate'], moment().valueOf());
    case SET_HYPER_TILES_PAGINATION_DATA:
      return state.setIn(['hyperTiles', 'pagination'], action.pagination);
    case RESET_HYPER_TILES_PAGINATION_DATA:
      return state.setIn(['hyperTiles', 'pagination'], {});
    case SELECT_HYPER_TILE:
      return state.set('selectedHyperTile', action.tile);
    case UPDATE_HYPER_TILE: {
      const index = _.findIndex(state.hyperTiles.content, tile => tile.id === action.tile.id);
      if (index !== -1) {
        return state.setIn(['hyperTiles', 'content', index], action.tile);
      }
      return state;
    }
    case SAVE_ALL_EXTENSIONS:
      return state.set('allExtensions', action.extensions);
    case SET_INTERCOM_LOCKS_FILTERED_BY_TAGS:
      return state.setIn(['selectedIntercom', 'locksFilteredByTags', action.index, 'data'], action.locks);
    case APPEND_INTERCOM_LOCKS_FILTERED_BY_TAGS:
      return state.setIn(['selectedIntercom', 'locksFilteredByTags', action.index, 'data'],
        [...state.selectedIntercom.locksFilteredByTags[action.index].data, ...action.locks]);
    case SET_INTERCOM_LOCKS_FILTERED_BY_TAGS_PAGINATION_DATA:
      return state.setIn(['selectedIntercom', 'locksFilteredByTags', action.index, 'pagination'], action.pagination);
    case SET_EXTENSION_USERS_FILTERED_BY_TAGS:
      return state.setIn(['selectedExtension', 'usersFilteredByTags', action.index, 'data'], action.users);
    case APPEND_EXTENSION_USERS_FILTERED_BY_TAGS:
      return state.setIn(['selectedExtension', 'usersFilteredByTags', action.index, 'data'],
        [...state.selectedExtension.usersFilteredByTags[action.index].data, ...action.users]);
    case SET_EXTENSION_USERS_FILTERED_BY_TAGS_PAGINATION_DATA:
      return state.setIn(['selectedExtension', 'usersFilteredByTags', action.index, 'pagination'], action.pagination);
    case SAVE_VIRTUAL_INTERCOM_LIMITS:
      return state.set('virtualIntercomLimits', action.limits);
    default:
      return state;
  }
} 

/*
virtual intercom DTO example
{
  "id": 0,
  "name": "string",
  "hyperTile": {
    "id": 0,
    "name": "string",
    "serialNumber": "string"
  },
  "smartLocks": [
    {
      "id": 0,
      "name": "string",
      "serialNumber": "string",
      "timeZone": "string",
      "battery": 0,
      "model": "string",
      "vendor": "ISEO",
      "firmwareVersion": "string",
      "hardwareVersion": "string",
      "featureLevel": "string",
      "bluetoothHardwareVersion": "string",
      "bluetoothFirmwareVersion": "string",
      "powerSourceType": "BATTERY",
      "creationDate": "2025-02-26T16:31:28.608Z",
      "updatedAt": "2025-02-26T16:31:28.608Z",
      "gatewayId": 0,
      "connectionType": "SMART",
      "hyperTagId": "string",
      "availableOffline": true,
      "availableOfflineMinutes": 0,
      "configuration": {
        "openMode": "string",
        "remoteOpenEnabled": true,
        "guestRemoteOpenEnabled": true,
        "group": "string",
        "groupMasterLockId": "string",
        "hooks": [
          {
            "event": "string",
            "action": "string",
            "data": "string",
            "url": "string",
            "headers": "string"
          }
        ]
      },
      "passageModeEnabled": true,
      "privacyModeEnabled": true,
      "customAttributes": {
        "additionalProp1": {},
        "additionalProp2": {},
        "additionalProp3": {}
      },
      "locationMedia": {
        "id": 0,
        "name": "string",
        "displayName": "string",
        "createdAt": 0,
        "link": "string"
      },
      "locationCoordinates": "string",
      "shared": true,
      "sharedFromHostname": "string",
      "capabilities": [
        "string"
      ],
      "geoHash": "string",
      "geoHashPrecision": 0,
      "passageModeState": "LIGHT"
    }
  ],
  "groups": [
    {
      "id": 0,
      "name": "string"
    }
  ],
  "enabled": true,
  "viewMode": "EXTENSIONS_LIST"
}
*/

/*
extension DTO example
{
  "id": 0,
  "name": "string",
  "group": {
    "id": 0,
    "name": "string"
  },
  "users": [
    {
      "id": 0,
      "username": "string",
      "firstname": "string",
      "lastname": "string",
      "email": "string",
      "registrationDate": "2025-02-26T16:19:33.693Z",
      "enabled": true,
      "languageType": "ENGLISH",
      "mobileUuid": "string",
      "mobileUuidState": "NEVER_SET",
      "mobileModel": "string",
      "mobileVersion": "string",
      "mobileOs": "string",
      "publicLink": "string",
      "phone": "string",
      "roles": [
        {
          "id": 0,
          "name": "string"
        }
      ],
      "tags": [
        {
          "id": 0,
          "name": "string",
          "color": "string",
          "type": "string",
          "extId": "string"
        }
      ],
      "companyName": "string",
      "mobileV364Uuid": "string",
      "extId": "string",
      "using2FA": true,
      "twoFactorType": "MAIL_OTP",
      "customAttributes": {
        "additionalProp1": {},
        "additionalProp2": {},
        "additionalProp3": {}
      },
      "withoutEmail": true,
      "accessProfileId": 0,
      "onlyEngine": true,
      "basicSubscription": true,
      "companyNotificationsEnabled": true,
      "invitationLimit": 0,
      "engineWithMobileApp": true,
      "privateUnit": true,
      "privateUnitId": 0,
      "canTogglePassageMode": true
    }
  ],
  "visibility": "HIDDEN"
}
*/

/*
extensionGroup DTO example
{
  "id": 0,
  "name": "string"
}
*/